if (!customElements.get("device-finder")) {
  customElements.define(
    "device-finder",
    class YearSearch extends HTMLElement {
      constructor() {
        super();
        this.getFilterURL = "";
        this.makeFilter = this.querySelector(".select__make_data");
        this.makeFilter?.addEventListener("change", this.getmodelData.bind(this));
        this.modelStoreData = "";
        this.modelFilter = this.querySelector(".select__model_data");
        this.searchURL = this.querySelector(".search__url");
        this.initmakeFilter();
      }

      resetDropdown(dropdown, placeholder) {
        dropdown.innerHTML = `<option value="select">${placeholder}</option>`;
        dropdown.disabled = true;
      }

      disableSearchLink() {
        this.searchURL.removeAttribute("href");
        this.searchURL.setAttribute("disabled", "true");
        this.searchURL.classList.add("disabled");
      }

      enableSearchLink(url) {
        this.searchURL.setAttribute("href", url);
        this.searchURL.removeAttribute("disabled");
        this.searchURL.classList.remove("disabled");
      }

      initmakeFilter() {
        fetch(`${deviceURL}?view=search.finder-device`)
          .then((response) => response.text())
          .then((response) => {
            let parser = new DOMParser(),
              newHTMlData = parser.parseFromString(response, "text/html"),
              getSelectValues = newHTMlData.querySelector(".select__make_data"),
              uniqueSelectDataList = [];

            for (var i = 0, n = getSelectValues.options.length; i < n; i++) {
              if (getSelectValues.options[i].value)
                uniqueSelectDataList.push(getSelectValues.options[i].value);
            }

            let uniqueDataArray = uniqueSelectDataList.filter(
              (item, index, arr) => arr.indexOf(item) == index
            );

            let initialData = `<option value="select">Device Make</option>`;
            uniqueDataArray.forEach((option) => {
              initialData += `<option value="${option}">${option}</option>`;
            });

            this.makeFilter.innerHTML = initialData;
          })
          .catch((err) => console.log(err));
      }

      getmodelData(e) {
        let selectmakeValue =
          this.makeFilter.options[this.makeFilter.selectedIndex].value;
        
        // If "select" option is chosen, reset and disable dependent elements
        if (selectmakeValue === "select") {
          this.disableSearchLink();
          this.resetDropdown(this.modelFilter, "Device Model");
        } else {
          // Update the modelStoreData with selected make value
          this.modelStoreData = selectmakeValue;
          this.getFilterURL = `${deviceURL}?filter.p.m.category.make=${this.modelStoreData}`;
          
          // Enable the search link with current URL
          this.enableSearchLink(this.getFilterURL);
      
          // Fetch and populate the model dropdown
          fetch(
            `${deviceURL}?filter.p.m.category.make=${this.modelStoreData}&view=search.finder-device`
          )
            .then((response) => response.text())
            .then((response) => {
              let parser = new DOMParser(),
                newHTMlData = parser.parseFromString(response, "text/html"),
                getSelectValues = newHTMlData.querySelector(".select__model_data"),
                uniqueSelectDataList = [];
      
              // Collect and filter unique model options
              for (var i = 0, n = getSelectValues.options.length; i < n; i++) {
                if (getSelectValues.options[i].value)
                  uniqueSelectDataList.push(getSelectValues.options[i].value);
              }
      
              let uniqueDataArray = uniqueSelectDataList.filter(
                (item, index, arr) => arr.indexOf(item) == index
              );
      
              // Create dropdown options for models
              let initialData = `<option value="select">Device Model</option>`;
              uniqueDataArray.forEach((option) => {
                initialData += `<option value="${option}">${option}</option>`;
              });
      
              // Populate and enable the model filter dropdown
              if (this.modelFilter !== null) {
                this.modelFilter.innerHTML = initialData;
                this.modelFilter.disabled = false;
      
                // Add event listener for final selection to trigger URL update
                this.modelFilter.addEventListener("change", () => {
                  let selectModelValue =
                    this.modelFilter.options[this.modelFilter.selectedIndex].value;
      
                  if (selectModelValue !== "select") {
                    this.getFilterURL = `${deviceURL}?filter.p.m.category.make=${this.modelStoreData}&filter.p.m.category.model=${selectModelValue}`;
                    this.enableSearchLink(this.getFilterURL);
                  } else {
                    this.disableSearchLink();
                  }
                });
              }
            })
            .catch((err) => console.log(err));
        }
      }   
    }
  );
}